import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose'
import { loadBreadPaymentSdk, runBreadBatchProcessing } from './helpers'
import { getLocationSearch, getLocationPathname } from 'selectors/getPageLocation'

const withLifeCycle = lifecycle({
  componentDidMount() {
    const { pathName, search } = this.props
    loadBreadPaymentSdk(() => runBreadBatchProcessing(pathName, search))
  }
})

export default compose(
  connect(state => ({
    search: getLocationSearch(state),
    pathName: getLocationPathname(state)
  }), {}),
  withLifeCycle)
